const removeNullValues = (obj) => {
  return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value !== null));
};
export {
  removeNullValues
};
//# sourceMappingURL=utils.js.map
